/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DocumentFolderFromJSON, DocumentFolderToJSON } from './DocumentFolder';
export function CreateDocumentFolderResponseDataFromJSON(json) {
    return CreateDocumentFolderResponseDataFromJSONTyped(json, false);
}
export function CreateDocumentFolderResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentFolder: !exists(json, 'document_folder') ? undefined : DocumentFolderFromJSON(json['document_folder'])
    };
}
export function CreateDocumentFolderResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_folder: DocumentFolderToJSON(value.documentFolder)
    };
}
